// extracted by mini-css-extract-plugin
export default {"button":"Button_button__jvzEt","primary":"Button_primary__wq6QU","outlined":"Button_outlined__U1iIF","small":"Button_small__CO9QG"};